import { Neo } from "@singularsystems/neo-react";
import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import LiabilityWriteUpFlexiReportCriteria from "./LiabilityWriteUpFlexiReportCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";

@NeoReport("LiabilityWriteUpFlexi", { category: ReportCategory.InvestorReports })
export default class LiabilityWriteUpFlexiReport extends Report<LiabilityWriteUpFlexiReportCriteria> {

    constructor(private contactApiClient = AppService.get(DomainTypes.ApiClients.Contact)) {
        super(LiabilityWriteUpFlexiReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.GridLayout >
                <Neo.FormGroup bindContext={this.criteria.meta.signatory1}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory1}
                        bindDisplay={this.criteria.meta.signatoryName1}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.signatory2}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory2}
                        bindDisplay={this.criteria.meta.signatoryName2}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.signatory3}>
                    <Neo.AutoCompleteDropDown
                        bind={this.criteria.meta.signatory3}
                        bindDisplay={this.criteria.meta.signatoryName3}
                        itemSource={this.contactApiClient.getContactLookups} />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </div>;
    }
}